import { createTheme } from '@nextui-org/react'

export const appTheme = createTheme({
  type: 'light',
  theme: {
    colors: {
      // brand colors just for COPPEL pagination.
      secondaryLight: '$green200',
      secondaryLightHover: '#729DC8',
      secondaryLightActive: '$#F7DD57',
      secondaryLightContrast: '#729DC8',
      secondary: '#F7DD57',
      secondaryBorder: '#729DC8',
      secondaryBorderHover: '#729DC8',
      secondarySolidHover: '#729DC8',
      secondarySolidContrast: '$white',
      secondaryShadow: '#729DC8',
      accents2: '#729DC8'
    }
  }
})
